const SuiteSynchonisationFieldsetDescription = () =>
  <>
    Disabling this prevents DAI from syncing with your script repository (DAI Server or Git Connections). Only do this if confident or using an alternative sync method such as custom scripts.
  </>

export default SuiteSynchonisationFieldsetDescription
